import { render, staticRenderFns } from "./DurationDialog.vue?vue&type=template&id=16582d1e&scoped=true"
import script from "./DurationDialog.vue?vue&type=script&lang=js"
export * from "./DurationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16582d1e",
  null
  
)

export default component.exports